import { render, staticRenderFns } from "./walletHistory.vue?vue&type=template&id=273d2841&scoped=true&"
import script from "./walletHistory.vue?vue&type=script&lang=js&"
export * from "./walletHistory.vue?vue&type=script&lang=js&"
import style0 from "./walletHistory.vue?vue&type=style&index=0&id=273d2841&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273d2841",
  null
  
)

export default component.exports